enum LeftNavRoutesEnumSb {
  DASHBOARD_MANAGEMENT = '/skybox/dashboard/management',
  DASHBOARD_OPERATIONS = '/skybox/dashboard/operations',
  DASHBOARD_BOT_PERFORMANCE = '/skybox/dashboard/bot-performance',
  DASHBOARD_FINANCE = '/skybox/dashboard/finance',
  DASHBOARD_BROKER = '/skybox/dashboard/broker',
  DASHBOARD_LISTER = '/skybox/dashboard/lister',
  DASHBOARD_BUYER = '/skybox/dashboard/buyer',
  DASHBOARD_CHECKER = '/skybox/dashboard/checker',
  DASHBOARD_SEATMAPCREATOR = '/skybox/dashboard/seat-map-creator',
  DASHBOARD_PERFORMANCE_ANALYSIS = '/skybox/dashboard/performance-analysis',
  //Zones
  ZONES_LISTING = '/skybox/zones/zone-listings',
  ZONES_LISTING_EDIT_EVENT_AVAILABILITY = '/skybox/zones/zone-listings/edit-event-metadata',
  ZONE_LISTINGS_ACTIVE_LISTINGS = '/skybox/zones/zone-listings/active-listings',
  ZONES_PENDING_FILLS = '/skybox/zones/pending-fills',
  ZONES_INSIGHTS = '/skybox/zones/insights',
  //Housekeeping
  HOUSEKEEPING_CANCELLED_SHOWS = '/skybox/housekeeping/cancelled-shows',
  HOUSEKEEPING_CANCELLED_SHOWS_ACTIVE = '/skybox/housekeeping/cancelled-shows/active',
  HOUSEKEEPING_CANCELLED_SHOWS_SOLD = '/skybox/housekeeping/cancelled-shows/sold',
  HOUSEKEEPING_CANCELLED_SHOWS_UNFILLED = '/skybox/housekeeping/cancelled-shows/unfilled',
  HOUSEKEEPING_CANCELLED_SHOWS_CANCELLED = '/skybox/housekeeping/cancelled-shows/cancelled',
  HOUSEKEEPING_EVENT_MAPPING = '/skybox/housekeeping/event-mapping',
  //Trading
  TRADING_VENUES = '/skybox/trading/venues',
  TRADING_EVENTS = '/skybox/trading/events',
  TRADING_EVENTS_CREATE_NEW_ZONE_LISTING = '/skybox/trading/events/create-new-zone-listing',
  TRADING_EVENTS_CREATE_NEW_ZONE_LISTING_BULK_PLACEMENT = '/skybox/trading/events/create-new-zone-listing/bulk-placement',
  TRADING_EVENTS_CREATE_NEW_ZONE_LISTING_WITHOUT_METADATA = '/skybox/trading/events/create-new-zone-listing-without-metadata',
  INSIGHTS_REPORTS = '/skybox/insights/reports',
  INSIGHTS_SCHEDULES = '/skybox/insights/schedules',
  MESSAGES_INBOX = '/skybox/messages/inbox',
  MESSAGES_ARCHIVES = '/skybox/messages/archives',
  MESSAGES_SENT = '/skybox/messages/sent',
  //Purchases
  PURCHASE_QUEUE = '/skybox/purchases/purchase-queue',
  //Shipping
  SHIPPING_QUEUE = '/skybox/shipping/shipping-queue',
  DELIVERED_TICKETS_REPORT = '/skybox/shipping/delivered-tickets',
}

enum ReportRoutesEnumSb {
  GROSS_PROFIT_REPORT = '/skybox/reports/profit-gross',
  PROFIT_DASHBOARD_REPORT = '/skybox/reports/profit-dashboard',
  LONG_INVENTORY_REPORT = '/skybox/reports/inventory-long',
  LONG_INVENTORY_NOT_LISTED_REPORT = '/skybox/reports/inventory-long-not-listed',
  LONG_INVENTORY_SCORECARD_REPORT = '/skybox/reports/long-inventory-scorecard-broker',
  BROKER_TAG_ISSUES_REPORT = '/skybox/reports/broker-tags-issues',
  CONSIGNMENT_SALES_REPORT = '/skybox/reports/consignment-sales',
  SHORTS_PENDING_DELIVERY_REPORT = '/skybox/reports/orders-pending-delivery',
  GROSS_PROFIT_CANCELLED_REPORT = '/skybox/reports/gross-profit-cancelled',
  CONSIGNMENT_PENDING_BUY_IN_REPORT = '/skybox/reports/consignment-pending-buy-in',
  INVOICES_NEEDING_ATTENTION = '/skybox/reports/invoices-needing-attention',
  RECEIVABLES_DETAILS = '/skybox/reports/receivables-wholesale-consignments',
  RECEIVABLES_RETAIL = '/skybox/reports/receivables-retail',
  RECEIVABLES_DETAILS_OLD = '/skybox/reports/receivables-wholesale-consignments-old',
  RECEIVABLES_RETAIL_OLD = '/skybox/reports/receivables-retail-old',
  ACTIVE_ZONE_LISTING_REPORT = '/skybox/reports/active-zone-listing-report',
  OTHER_COSTS_AND_CREDITS = '/skybox/reports/other-costs-and-credits-report',
}

enum LeftNavMenuKeysEnumSb {
  DASHBOARD = '/dashboard',
  ZONES = '/zones',
  TRADING = '/trading',
  PURCHASES = '/purchases',
  SHIPPING = '/shipping',
  HOUSEKEEPING = '/housekeeping',
  INSIGHTS = '/insights',
  MESSAGES = '/messages',
}

export { LeftNavRoutesEnumSb, LeftNavMenuKeysEnumSb, ReportRoutesEnumSb };
